// src/components/membership/DisabledCreditButton.js
import React from 'react';
import { useBalance } from '../../contexts/BalanceContext';
import Tooltip from '../Tooltip';

/**
 * A button that disables itself when the user doesn't have enough credits
 */
const DisabledCreditButton = ({ 
  serviceType,
  onClick,
  children,
  className = '',
  disabled = false,
  ...rest
}) => {
  const { creditBalance, SERVICE_COSTS } = useBalance();
  
  // Get cost for this service
  const cost = SERVICE_COSTS[serviceType] || 0;
  
  // Check if user has enough credits
  const hasEnoughCredits = creditBalance && creditBalance.credits >= cost;
  
  // Combined disabled state
  const isDisabled = disabled || !hasEnoughCredits;
  
  // Custom click handler to prevent clicks when disabled
  const handleClick = (e) => {
    if (isDisabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    
    if (onClick) {
      onClick(e);
    }
  };
  
  // Reason for disabling due to insufficient credits
  const reason = !hasEnoughCredits ? 
    `Requires ${cost} credits. You have ${creditBalance?.credits || 0}.` : 
    null;
  
  // Button element with pointer-events-none when disabled
  const button = (
    <button
      type="button"
      className={`${className} ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      disabled={isDisabled}
      onClick={handleClick}
      style={isDisabled ? { pointerEvents: 'none' } : {}}
      {...rest}
    >
      {children}
    </button>
  );
  
  // Add tooltip if disabled due to insufficient credits
  if (!hasEnoughCredits && reason) {
    return (
      <div className="inline-block" onClick={(e) => e.stopPropagation()}>
        <Tooltip text={reason}>
          <div onClick={(e) => e.stopPropagation()}>
            {button}
          </div>
        </Tooltip>
      </div>
    );
  }
  
  return button;
};

export default DisabledCreditButton;